<div class="filters-card gap-1em">

    <!-- Prestador -->
    <div class="flex-column p-2">
        <div class="mbs-2">
            <span class="subtitle-3 text-primary">{{ 'modules.schedule.filter.prestador' | exp:'':'Prestador' }}</span>
        </div>
        <div class="flex-row align-space-between-start  ">
            <app-select-searching-input class="flex-50" [name]="PROVIDERS_SELECTED" [elements]="providersList"
                [defaultValue]="!!providerId ? +providerId : null" [nameSearching]="PROVIDER_SEARCHING"
                [form]="scheduleForm" (selected)="selectedProvider($event)"
                [placeholder]="!!providerSelected ? calculateNameProvider(providerSelected) : ('modules.schedule.filter.placeholders.seleccione-el-prestador' | exp:'':'Seleccione el prestador')"
                [calculateId]="calculateIdProvider" [calculateName]="calculateNameProvider"
                [placeholderNoValue]="('modules.schedule.filter.placeholders.sin-resultados' | exp:'':'Sin resultados')"
                [placeholderSearching]="('modules.schedule.filter.placeholders.buscar-prestador' | exp:'':'Buscar prestador') + '...'" [disabled]="">
            </app-select-searching-input>
            <button mat-button type="button" class="flex-row" [disabled]="!providerSelected" (click)="providerSelected ? openReadOnly(providerSelected.id) : null">
                <mat-icon svgIcon="provider-docs-primary"></mat-icon>
                <span class="subtitle-4 underline cursor-pointer">
                    {{ 'modules.schedule.filter.ver-documentacion' | exp:'':'Ver documentación' }}
                </span>
            </button>
        </div>
    </div>

    <div class="flex-column pls-2 gap-1em mbs-2">
        <div class="flex-row gap-1em align-start-center">

            <span class="subtitle-card-1">{{ 'modules.schedule.filter.incluir-casos' | exp:'':'Incluir casos' }}</span>

            <!-- Abiertos -->
            <app-switcheable-chip [form]="scheduleForm" name="openCases" [text]="'modules.schedule.filter.abiertos' | exp:'':'Abiertos'" [active]="showOpenCtrl.value"
                (change)="showOpenCtrl.setValue($event);" [disabled]="!providerSelected" />

            <!-- Cerrados -->
            <app-switcheable-chip [form]="scheduleForm" name="closedCases" [text]="'modules.schedule.filter.cerrados' | exp:'':'Cerrados'"
                [active]="showClosedCtrl.value" (change)="showClosedCtrl.setValue($event)"
                [disabled]="!providerSelected" />
        </div>

        <!-- <app-checkbox-input
            [form]="scheduleForm" [label]="('modules.schedule.filter.incluir-acuerdos-inactivos' | exp:'':'Incluir acuerdos inactivos')" (change)="showInactiveAgreementsCtrl.setValue($event);"
            [name]="this.INCLUDE_INACTIVE_AGREEMENTS" [disabled]="!this.scheduleForm">
        </app-checkbox-input> -->
    </div>

    <!-- Card Pacientes con agenda (se muestra si hay prestadores y se cargó data) -->
    <ng-container *ngIf="(loadingFilteredAllPatients && casesFiltered.length > 0) else loadingResponse">
        <div class="flex-column">
            <div class="flex-row patients-card-top bg-primary-lighter">
                <mat-form-field appearance="outline" class="flex-100 no-outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput [placeholder]="('modules.schedule.filter.buscar-paciente-por-nombre-apellido' | exp:'':'Buscar paciente por nombre, apellido')" [formControl]="searchCtrl">
                </mat-form-field>
            </div>
            <div>
                <div class="patients-card-bottom">
                    <div *ngFor="let row of filteredPatientsWithCases; trackBy: trackByPatient" class="patients-list">
                        <div class="patient-row" (click)="onRowCheckboxChange(!selection.isSelected(row), row)">
                            <mat-checkbox (click)="$event.stopPropagation()" [checked]="selection.isSelected(row)"
                                [disabled]="isCheckboxDisabled(row)"
                                (change)="onRowCheckboxChange($event.checked, row)">
                            </mat-checkbox>
                            <div class="flex-row align-start-center">
                                <span class="subtitle-3 name text-primary text-ellipsis flex-30 ">{{ row.surname }}
                                    {{ row.name }} </span>
                                <div class="flex-1" *ngIf="row.cases?.length > 1" (click)="toggleExpand(row, $event)">
                                    <div
                                        class="flex-row gap-0-5em bg-primary-lighter border-primary-lighter show-casees-chip">
                                        <span class="subtitle-6 text-primary">{{ isExpanded(row) ? ('modules.schedule.filter.cerrar' | exp:'':'cerrar') : ('modules.schedule.filter.ver' | exp:'':'ver') }}</span>
                                        <span class="subtitle-6"
                                            [ngClass]="{'text-primary-darker' : !isExpanded(row), 'text-white' :  isExpanded(row)}">{{
                                            row.cases.length }}</span>
                                    </div>
                                </div>
                            </div>

                            <span class="subtitle-3 name text-primary-darker dni-label">
                                {{ 'modules.schedule.filter.dni' | exp:'':'DNI' }}
                                <a class="dni-number subtitle-3 name text-primary mls-2">{{ row.documentNumber }}</a>
                            </span>

                            <mat-icon *ngIf="row.cases?.length === 1" class="open cursor-pointer"
                                svgIcon="arrow-square-green" (click)="openExternalUrl(row.cases[0].id)">
                            </mat-icon>
                        </div>

                        <!-- ROW CASES -->
                        <div class="children-wrapper mls-4"
                            [@detailExpand]="isExpanded(row) ? 'expanded' : 'collapsed'">
                            <div class="patient-row child" *ngFor="let c of row.cases; trackBy: trackByCase">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    [checked]="selection.isSelected(c.patient)"
                                    [disabled]="isCheckboxDisabled(c.patient)"
                                    (change)="onRowCheckboxChange($event.checked, c.patient)">
                                </mat-checkbox>
                                <span class="subtitle-3 name text-ellipsis">
                                    {{ c.patient.surname }} {{ c.patient.name }}
                                </span>
                                <span [ngClass]="{'case-active-chip': c?.active, 'case-inactive-chip': !c?.active}">
                                    {{ c?.active ? (('modules.schedule.filter.abierto' | exp:'':'Abierto') ) : (('modules.schedule.filter.cerrado' | exp:'':'Cerrado') ) }}
                                </span>
                                <mat-icon class="open cursor-pointer" svgIcon="arrow-square-green"
                                    (click)="openExternalUrl(c.id)">
                                </mat-icon>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <div class="flex align-center-center">
            <button class="flex-40 align-center-center flex-row" mat-flat-button color="primary" (click)="onClickLoadSchedule()"
                [disabled]="!providerSelected || selection.isEmpty() || isLoadingAttentionsProcess()">
                @if(isLoadingAttentionsProcess()){
                    <mat-spinner color="accent" diameter="20"></mat-spinner>
                } @else {
                    <span class="flex-70 subtitle-4">{{ 'modules.schedule.filter.ver-agenda' | exp:'':'Ver Agenda' }}</span>
                }
            </button>
        </div>
    </ng-container>

    <ng-template #loadingResponse>
        <div class="flex-column align-center-center">
            @if(isLoadingGetAgreementsByProvidersIds() || isLoadingGettingProviders()) {
                <mat-spinner color="primary" diameter="30">
                </mat-spinner>
            }
            @if(filteredPatientsWithCases.length === 0 && !isLoadingGetAgreementsByProvidersIds() && !isLoadingGettingProviders()) {
                <div class="pys-5">
                    <span class="flex full-width align-center-center pls-3 subtitle-2">{{ 'modules.schedule.filter.no-hay-casos-para-este-prestador' | exp:'':'No hay casos para este prestador' }}</span>
                </div>
            }
        </div>
    </ng-template>

    <!-- Host para renderizar ProvidersManagementComponent dentro de DialogComponent -->
    <ng-template #providerDSPHost>
        <ng-container *ngComponentOutlet="providersManagementCmp; injector: dspInjector">
        </ng-container>
    </ng-template>
</div>
